import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import ContactQuote from "./sections/ContactQuote";
import HowItWorks from "./sections/HowItWorks";
import WhyChooseCashHome from "./sections/WhyChooseCashHome";
import OurProcess from "./sections/OurProcess";
import Testimonials from "./sections/Testimonials";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import AboutUs from "./sections/AboutUs";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <ContactQuote />
      <HowItWorks />
      <WhyChooseCashHome />
      <OurProcess />
      <Testimonials />
      <FrequentlyAskedQuestions />
      <AboutUs />
      <Footer />
    </div>;
}